import { useEffect, useMemo } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import TabNavigation from '../components/TabNavigation'
import Overview from '../components/dashboard/Overview'
import VisitEffectiveness from '../components/dashboard/VisitEffectiveness'
import NBVRecommendations from '../components/dashboard/NBVRecommendations'
import NetworkCoverage from '../components/dashboard/NetworkCoverage'
import KAMPerformance from '../components/dashboard/KAMPerformance'
import StockOverview from '../components/dashboard/StockOverview'
import { useUser } from '../context/UserContext'
import { ReportPage } from '../components/report-shell'

const allDashboardTabs = [
  { id: 'overview', label: '🏠 Przegląd', icon: 'Home', requiresOperators: null },
  { id: 'visits', label: '📋 Efektywność wizyt', icon: 'Calendar', requiresOperators: ['ORANGE', 'PLUS'] },
  { id: 'coverage', label: '🗺️ Pokrycie sieci', icon: 'Map', requiresOperators: ['ORANGE', 'PLUS', 'TMOBILE', 'P4'] },
  { id: 'performance', label: '📈 Performance KAM', icon: 'TrendingUp', requiresOperators: ['ORANGE', 'PLUS', 'TMOBILE', 'P4'] },
  { id: 'stock', label: '📦 Zatowarowanie salonów', icon: 'Package', requiresOperators: ['ORANGE', 'PLUS', 'TMOBILE', 'P4'] },
]

const Dashboard = () => {
  const { hasOperatorAccess } = useUser()
  const { tab } = useParams()
  const navigate = useNavigate()

  const activeTab = tab || 'overview'

  // Filter tabs based on user's operator access
  const dashboardTabs = useMemo(() => allDashboardTabs.filter(tab => {
    if (!tab.requiresOperators) return true
    return tab.requiresOperators.some(op => hasOperatorAccess(op))
  }), [hasOperatorAccess])

  // Redirect to overview if tab is unknown or inaccessible
  useEffect(() => {
    const tabIds = dashboardTabs.map(t => t.id)
    if (activeTab !== 'overview' && !tabIds.includes(activeTab)) {
      navigate('/dashboard', { replace: true })
    }
  }, [dashboardTabs, activeTab, navigate])

  const handleTabChange = (tabId) => {
    if (tabId === 'overview') {
      navigate('/dashboard')
    } else {
      navigate(`/dashboard/${tabId}`)
    }
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview />
      case 'visits':
        return <VisitEffectiveness />
      case 'nbv':
        return <NBVRecommendations />
      case 'coverage':
        return <NetworkCoverage />
      case 'performance':
        return <KAMPerformance />
      case 'stock':
        return <StockOverview />
      default:
        return <Overview />
    }
  }

  return (
    <ReportPage>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <TabNavigation
            tabs={dashboardTabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
        </div>
        <div className="min-h-96">
          {renderTabContent()}
        </div>
      </div>
    </ReportPage>
  )
}

export default Dashboard
